import { ENV } from "./utils/const";

import React from "react";

import { RouteRecord } from "vite-react-ssg";


const Home = React.lazy(() => import("./pages/Home"));
const Tos = React.lazy(() => import('./pages/Tos'));

const Login = React.lazy(() => import("./pages/Login"));
const Dashboard = React.lazy(() => import("./pages/Dashboard"));
const Admin = React.lazy(() => import("./pages/Admin"));
const Plan = React.lazy(() => import('./pages/Plan'));
const Payment = React.lazy(() => import('./pages/Payment'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const GoogleDisclosure = React.lazy(() => import("./pages/GoogleDisclosure"));
const ForFreelancer = React.lazy(() => import("./pages/ForFreelancer"));
const SchedulerPage = React.lazy(() => import("./pages/SchedulerPage"));
const Blog = React.lazy(() => import("./pages/Blog"));
const PageNotFound = React.lazy(() => import("./pages/page404"));
const McpDone = React.lazy(() => import("./pages/McpDone"));

import { blogRoutes } from "./_blog/routes";

import ErrorBoundary from './components/ErrorBoundary';


const staticPaths: RouteRecord[] = [
  { path: "", Component: Home },
  { path: "privacy", Component: Privacy },
  { path: "tos", Component: Tos },
  { path: "google-privacy", Component: GoogleDisclosure },
  { path: "for-freelancers", Component: ForFreelancer },
  { path: "blog", Component: Blog },
  { path: "login", Component: Login },
  { path: "dashboard", Component: Dashboard },
  { path: "mcp-done", Component: McpDone },
  { path: "admin", Component: Admin },
  { path: "plan", Component: Plan },
  { path: "payment", Component: Payment },
  { path: "book", Component: SchedulerPage },
  { path: "*", Component: PageNotFound }
]

// Static routes
let routes: RouteRecord[] = staticPaths.map(
  route => ["/", "/en/", "/fr/", "/it/", "/es/"].map(
    (language) => (
      {
        path: language.concat(route.path!),
        Component: route.Component,
        ErrorBoundary: ErrorBoundary,
      }
    )
  )
).flat()

// Blog routes
routes = routes.concat(
  blogRoutes.map(
    ([url, Component]) => (
      { path: `${url}`, Component: Component, ErrorBoundary: ErrorBoundary } as RouteRecord)
  )
);

export default routes;